<template>
  <div>
    <v-snackbar v-model="show" :color="type">
      {{ message }}
      <v-btn text @click.native="show = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>
<script>
    import {mapGetters} from 'vuex'

    export default {
        name: 'Notify',
        props: ['notification'],
        data() {
            return {
                show: false,
                message: ''
            }
        },
        computed: {
            ...mapGetters({
                permission: 'notifications/permission'
            }),
            type() {
                let color = 'indigo'
                switch (this.notification.category) {
                    case 'Alert':
                        color = 'secondary'
                        if (this.notification.action.toLowerCase() == 'confirm') {
                            color = 'success'
                        }
                        break
                    case 'Message':
                        color = 'accent'
                        break
                }
                return color
            },
            icon() {
                let icon = 'mdi-information'
                switch (this.notification.category) {
                    case 'Alert':
                        icon = 'mdi-alert'
                        break
                    case 'Message':
                        icon = 'mdi-chat'
                        break
                    case 'Application':
                        icon = 'mdi-account-box-multiple'
                        break
                }
                return icon
            },
        },
        mounted() {
            if (this.permission === 'granted' && !document.hasFocus()) {
                let n = new Notification(this.notification.short_description)
                return n
            } else {
                this.show = true
                this.message = this.notification.short_description
            }
        }
    }
</script>
